module.exports = __webpack_public_path__ + "static/media/q_type_5.79a32db3.png";